module.exports = __webpack_public_path__ + "static/fail-banner-desktop-4e212d2bb89079849cd5e5b898105643.jpg";